import { Card } from "../../../components/Card";
import { TYPE_COLORS } from "../utils/constant";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";

export function GoalCard({ title, value, totalValue, type, isCompleted, countText }: {
    title: string;
    value: number;
    type: string;
    isCompleted: boolean;
    countText: string;
    totalValue: number;
}) {
    const typeColors = TYPE_COLORS[type];
    const progressPercentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
    return (
        <Card className="!p-3 !rounded-[5px] flex items-center justify-between" style={{ background: typeColors.bgGradient }}>
            <div className="flex flex-col gap-4 flex-[4]">
                <span>{title}</span>
                <div className="flex items-center gap-2">

                    <div
                        className={`flex-1 flex-1 h-[9px] overflow-hidden rounded-full bg-white`}
                    >
                        <div
                            className={`h-[9px] rounded-full`}
                            style={{
                                width: `${progressPercentage || 0}%`,
                                backgroundColor: typeColors.streakBackgroundColor,
                            }}
                        />
                    </div>
                    <span>{countText}</span>
                </div>
            </div>
            <div className="flex-[1] flex justify-end">
                <div
                    className="w-4 h-4 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: isCompleted ? typeColors.streakBackgroundColor : "#999999" }}
                >
                    <CheckIcon className="[&_path]:stroke-white h-3 w-3 [&_path]:stroke-[1.75px]" />
                </div>
            </div>
        </Card>
    )
}